import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import UpgradeForm from "@/components/sections/UpgradeForm";

export default function Upgrade() {
    const [params] = useSearchParams();
    const submitted = params.get("submitted") === "1";
    useEffect(() => { document.title = "Upgrade to Styletto IX | Hearing Aid Exchange Program"; }, []);

    if (submitted) {
        return (
            <section className="section">
                <div className="container-x max-w-[640px] text-center">
                    <CheckCircle2 size={56} className="text-[#003E4D] mx-auto" />
                    <h1 className="font-serif text-[40px] md:text-[52px] mt-6">Thank you.</h1>
                    <p className="mt-4 text-[16px] text-[#4a5568] leading-relaxed">
                        Our Styletto expert will contact you within 24 hours to evaluate your old device
                        and confirm your upgrade benefit. In the meantime, feel free to WhatsApp us if
                        you'd like to speak immediately.
                    </p>
                </div>
            </section>
        );
    }

    return (
        <>
            <section className="pt-24 pb-6 md:pt-36 md:pb-10">
                <div className="container-x max-w-[820px]">
                    <p className="eyebrow">Upgrade Program</p>
                    <h1 className="font-serif text-[44px] md:text-[64px] leading-[1.04] mt-3">
                        Trade in your old hearing aid.
                        <br />
                        <span className="italic text-[#003E4D]">Step up to Styletto IX.</span>
                    </h1>
                </div>
            </section>
            <UpgradeForm />
        </>
    );
}
